export function Logo({ variant = "horizontal", tone = "dark", className = "" }) {
  const color = tone === "dark" ? "text-ink" : "text-ivory";
  if (variant === "compact") {
    return (
      <span className={`relative grid h-10 w-10 place-items-center border border-current ${color} ${className}`}>
        <span className="display text-[1.5rem] leading-none">S</span>
        <span className="absolute -right-[3px] -top-[3px] h-[6px] w-[6px] bg-accent" />
      </span>
    );
  }
  if (variant === "stacked") {
    return (
      <span className={`inline-flex flex-col leading-none ${color} ${className}`}>
        <span className="flex items-start gap-1.5">
          <span className="display text-[2.8rem] font-semibold tracking-[0.04em]">SANAA</span>
          <span className="mt-2 h-2 w-2 bg-accent" />
        </span>
        <span className="mt-2 font-mono text-[11px] tracking-[0.3em]">DESIGN STUDIO</span>
      </span>
    );
  }
  return (
    <span className={`inline-flex items-center gap-2.5 leading-none ${color} ${className}`}>
      <span className="display text-[1.55rem] font-semibold tracking-[0.04em]">SANAA</span>
      <span className="h-1.5 w-1.5 bg-accent" />
      <span className="font-mono text-[10px] leading-[1.3] tracking-[0.18em]">DESIGN<br />STUDIO</span>
    </span>
  );
}
